import React from 'react';

import ax from '../asset/ax.png';
import back from '../asset/back.png'

import dabangBridge from '~/utils/bridge';

import { 
  Wrapper, 
  Container,
  ResultWrap,
  ResultImg,
  ResultWrap2,
  ResultImg2,
  ActionGroup,
} from './styled';

const MissionResultToast = ({
  missionResultImg,
  closeModal, 
  type = '',
}) => {

  const handler = () => {
    dabangBridge.android(call => {
      call.finishActivity();
    });

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'finishActivity',
      });
    });
  }

  return (
    <Wrapper>
      <Container imgUrl ={missionResultImg} >
        <ActionGroup>
            {type === "mission2" ? (
              <ResultWrap2 onClick={handler}>
                <ResultImg2 imgUrl={back}/>
              </ResultWrap2> 
            ) : (
              <ResultWrap onClick={closeModal}>
                <ResultImg imgUrl ={ax}/>
              </ResultWrap>
            )}
        </ActionGroup>
      </Container>
    </Wrapper>
  )
}

export default MissionResultToast;
